import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Container } from 'semantic-ui-react';
import authHelpers from 'utils/authHelpers';
import Nav from 'ui/Nav';
import AppHeader from 'ui/AppHeader';

const AuthenticatedShell = ({ children }) => (
  <>
    <AppHeader />
    <Container className="authenticated-shell-main">
      {children}
    </Container>
    <Nav />
  </>
);

export const MicroRoute = ({ children, ...rest }) => {
  const token = authHelpers.getToken();

  if (token) {
    const component = React.cloneElement(children);

    return (
      <Route {...rest}>
        <AuthenticatedShell>
          { component }
        </AuthenticatedShell>
      </Route>
    );
  }

  return <Redirect to="/" />;
};
